document.addEventListener('DOMContentLoaded', function () {
  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // Qty stepper
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var val = stepper.querySelector('.qty-val');
    stepper.querySelector('[aria-label="Increase quantity"]').addEventListener('click', function () {
      val.textContent = parseInt(val.textContent) + 1;
    });
    stepper.querySelector('[aria-label="Decrease quantity"]').addEventListener('click', function () {
      var n = parseInt(val.textContent);
      if (n > 1) val.textContent = n - 1;
    });
  });
});
